lmApp.
  directive('lmSelect', ['$window', '$document', '$timeout',
    function ($window, $document, $timeout) {
      return {
        restrict: 'E',
        replace: true,
        scope: {
          ngModel: '=',
          options: '=',
          placeholder: '@',
          limit: '@',
          withSearch: '@',
          loading: '=?',
          error: '@',
          errorFn: '&',
          warning: '@',
          warningFn: '&',
          success: '@',
          successFn: '&',
          noData: '@',
          ngDisabled: '=?',
          optionSection: '@',
          optionType: '@',
          onFocus: '&',
          onBlur: '&',
          onSelect: '&',
          onSearch: '&'
        },
        link: function (scope, element, attrs) {
          scope._select_element_ = element;
          scope._input_ = element.find('#hidden_input');
          scope._arrow_ = element.find('.mdi-chevron-down');
          scope._options_ = element.find('ul');
          scope._uniqId = makeid(10);
          scope._search_ = element.find('#search' + scope._uniqId);
          scope._empty_ = angular.element('<div id="empty" style="opacity: 0.7; width: 100%; left: 0; top: 0;"></div>');
          scope._empty_.css({'z-index': +scope._options_.css('z-index') - 1});

          if (typeof scope.errorFn !== 'function') {
            scope.errorFn = function () {
              return scope.errorFn;
            }
          }
          if (typeof scope.warningFn !== 'function') {
            scope.warningFn = function () {
              return scope.warningFn;
            }
          }
          if (typeof scope.successFn !== 'function') {
            scope.successFn = function () {
              return scope.successFn;
            }
          }

          if (!angular.isArray(scope.options)) {
            scope.localOptions = [];
          }

          scope.optWatcher = scope.$watchCollection('options', function (newValue, oldValue) {
            if (newValue) {
              scope.localOptions = angular.copy(newValue);
            }
          });

          scope._ChangePosition = function () {
            scope._options_.css({
              overflow: 'hidden',
              top: scope._input_.offset().top - $document.scrollTop(),
              left: scope._input_.offset().left - $document.scrollLeft()
            });
          };

          scope._ChangeSize = function () {
            scope._options_.css({width: scope._select_element_.width()});

            var bodyHeight = $document[0].documentElement.clientHeight;
            var optionsHeight = scope._options_.height();
            var optionsOffsetTop = scope._input_.offset().top - $document.scrollTop();
            var bodyScrollTop = angular.element('body').scrollTop();

            if (optionsHeight + optionsOffsetTop > bodyHeight) {
              scope._options_.css({height: bodyHeight - optionsOffsetTop + bodyScrollTop - 10});
            }
          };

          scope._ActivateOption = function (options, newOption) {
            scope._options_.find('li.active').removeClass('active');
            angular.element(newOption).addClass('active');

            if (_isOutOfScroll(newOption)) {
              scope._options_.scrollTop(scope._options_.scrollTop() + angular.element(newOption).position().top);
            }
          };

          scope._SelectOption = function (option) {
            angular.element(option).trigger('click');
          };

          var _isOutOfScroll = function (li, partial) {
            var contHeight = scope._options_.height();
            var contTop = scope._options_.scrollTop();
            var contBottom = contTop + contHeight;

            var elemTop = angular.element(li).offset().top - scope._options_.offset().top;
            var elemBottom = elemTop + angular.element(li).height();

            var isTotal = (elemTop >= 0 && elemBottom <= contHeight);
            var isPart = ((elemTop < 0 && elemBottom > 0 ) || (elemTop > 0 && elemTop <= scope._options_.height())) && partial;

            return !isTotal && !isPart;
          };

          var _OpenSelect = function () {
            if (scope.ngDisabled) return;

            if (scope.onFocus) scope.onFocus();

            scope._empty_.appendTo('body');
            scope._options_.appendTo('body');

            scope._ChangePosition();

            scope._options_.css({overflow: 'hidden'});
            scope._options_.css({display: 'block'});

            scope._options_.css({width: scope._select_element_.width()});

            TweenMax.from(scope._options_, 0.35, {
              height: 0,
              ease: Expo.easeInOut,
              onComplete: function () {
                scope._options_.css({'overflow-y': 'auto'});
                if (scope.withSearch) scope._search_.focus();
                scope._ChangeSize();

                scope._empty_.bind('click', _CloseSelect);
              },
              clearProps: 'height'
            });

            scope._input_.trigger('focus');
            angular.element('body').bind('keydown', _OnKeyDown);
            angular.element($window).bind('resize', scope._ChangePosition);
            angular.element($window).bind('resize', scope._ChangeSize);
            angular.element($window).bind('scroll', scope._ChangePosition);
          };

          var _CloseSelect = function (event) {
            scope._options_.css({overflow: 'hidden'});

            TweenMax.to(scope._options_, 0.35, {
              height: 0,
              display: 'none',
              ease: Expo.easeInOut,
              onComplete: function () {
                scope._options_.css({'overflow-y': 'auto'});
                scope._empty_.remove();
              },
              clearProps: 'height,width'
            });

            scope._empty_.unbind('click', _CloseSelect);
            angular.element('body').unbind('keydown', _OnKeyDown);
            angular.element($window).unbind('resize', scope._ChangePosition);
            angular.element($window).unbind('resize', scope._ChangeSize);
            angular.element($window).unbind('scroll', scope._ChangePosition);
            if (scope.onBlur) scope.onBlur();
          };

          var activeOption;
          var newOption;
          var _OnKeyDown = function (event) {
            // TAB - switch to another input
            if (event.which == 9) {
              if (event.preventDefault) event.preventDefault();
              if (event.stopPropagation) event.stopPropagation();
              _CloseSelect(event);
            }

            // ENTER - select option and close when select options are opened
            if (event.which == 13) {
              if (event.preventDefault) event.preventDefault();
              if (event.stopPropagation) event.stopPropagation();
              activeOption = _.head(scope._options_.find('li.active:not(.disabled)'));
              if (activeOption) {
                scope._SelectOption(activeOption);
              }
            }

            //ARROW DOWN - move to next not disabled option
            if (event.which == 40) {
              if (event.preventDefault) event.preventDefault();
              if (event.stopPropagation) event.stopPropagation();
              newOption = _.head(scope._options_.find('li.active').next('li:not(.disabled)'));
              if (newOption) {
                scope._ActivateOption(scope.localOptions, newOption);
              } else if (scope._options_.find('li:not(.disabled)').length) {
                scope._ActivateOption(scope.localOptions, _.head(scope._options_.find('li:not(.disabled)')));
              }
            }

            // ESC - close options
            if (event.which == 27) {
              if (event.preventDefault) event.preventDefault();
              if (event.stopPropagation) event.stopPropagation();
              _CloseSelect();
            }

            // ARROW UP - move to previous not disabled option
            if (event.which == 38) {
              if (event.preventDefault) event.preventDefault();
              if (event.stopPropagation) event.stopPropagation();
              newOption = _.head(scope._options_.find('li.active').prev('li:not(.disabled)'));
              if (newOption) {
                scope._ActivateOption(scope.localOptions, newOption);
              } else if (scope._options_.find('li:not(.disabled)').length) {
                scope._ActivateOption(scope.localOptions, _.last(scope._options_.find('li:not(.disabled)')));
              }
            }
          };

          scope._input_.bind('click', _OpenSelect);
          scope._arrow_.bind('click', _OpenSelect);

          scope.selectOption = function (option) {
            scope.ngModel = option;
            if (scope.onSelect) {
              var f = scope.onSelect();
              if (typeof f == 'function') {
                f(option);
              }
            }
            _CloseSelect();
          };

          scope.clearSearch = function () {
            scope.search = '';
            scope._search_.focus();
          };

          scope.toCreate = function (path) {
            if (path) window.location.href = path;
          };

          scope.searchWatcher = scope.$watch('search', function (newValue, oldValue) {
            if (typeof scope.onSearch == 'function') {
              var f = scope.onSearch();
              if (typeof f == 'function') {
                f(newValue);
              }
            }
          });

          scope.limitWatcher = scope.$watch('limit', function (newValue, oldValue) {
            if (newValue) {
              scope._ChangeSize();
              if (scope.withSearch) {
                scope._search_.focus();
              } else {
                scope._options_.focus();
              }
            }
          });

          scope._select_element_.on('$destroy', function () {
            scope._input_.unbind('click', _OpenSelect);
            scope._arrow_.unbind('click', _OpenSelect);
            scope.optWatcher();
            scope.limitWatcher();
            scope.searchWatcher();
          });
        },
        templateUrl: 'lm-select/lm-select.tpl.html'
      };
    }]);

function makeid(length) {
  var result           = '';
  var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for ( var i = 0; i < length; i++ ) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}
